import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';

// Vue.use(Vuex);

function getQueryStringValue (key) { // Old solution that mantains old browser support https://stackoverflow.com/questions/9870512/how-to-obtain-the-query-string-from-the-current-url-with-javascript
  // eslint-disable-next-line no-useless-escape
  return decodeURIComponent(window.location.search.replace(new RegExp('^(?:.*[&\\?]' + encodeURIComponent(key).replace(/[\.\+\*]/g, '\\$&') + '(?:\\=([^&]*))?)?.*$', 'i'), '$1'));
}

// We keep the storage session for 1day -> Clean older sessions
const removeSessionsAfter = 86400; // 1day in seconds
const currentDate = new Date();

for (let i = localStorage.length - 1; i >= 0; i--) {
  const itemKey = window.localStorage.key(i);

  try {
    const itemNumber = Number(itemKey);
    const storeDate = new Date(itemNumber);
    const dif = currentDate.getTime() - storeDate.getTime();

    if (dif > removeSessionsAfter * 1000) {
      window.localStorage.removeItem(itemKey);
    }
  } catch {
    // No number, ignoring
  }
}

// We get the current window key
let storeKey = window.sessionStorage.getItem('windowKey');

// We check if we are entry from a new "session"
const isNewEntrance = !!getQueryStringValue('workspace') && !!getQueryStringValue('product') && !!getQueryStringValue('offer');

// If the user cameback from gateway and it has a reference, we find the reference in the local storage the associate the order reference
if (!isNewEntrance && !storeKey && getQueryStringValue('reference')) { // window.location.pathname && window.location.pathname.toLowerCase().endsWith('/gateway')
  for (let i = 0; i < window.localStorage.length; i++) {
    const itemKey = window.localStorage.key(i);
    let itemValue = window.localStorage.getItem(itemKey);
    let isJson = false;

    try {
      itemValue = JSON.parse(itemValue);
      isJson = true;
    } catch {
    // Not json
    }

    if (isJson && itemValue && getQueryStringValue('reference').includes(itemValue.bookingId)) {
      storeKey = itemKey;
      sessionStorage.setItem('windowKey', storeKey);
    }
  }
}

// If we open the url in the new tab, we grab the most recent
if (!isNewEntrance && !storeKey && window.localStorage.length) {
  let mostRecent = 0;
  for (let i = 0; i < window.localStorage.length; i++) {
    const itemKey = window.localStorage.key(i);
    try {
      const itemNumber = Number(itemKey);
      if (itemNumber > mostRecent) {
        mostRecent = itemNumber;

        storeKey = itemKey;
        sessionStorage.setItem('windowKey', storeKey);
      }
    } catch {
      // No number, ignoring
    }
  }
}

// Set new key
if (!storeKey) {
  storeKey = Date.now();
  sessionStorage.setItem('windowKey', storeKey);
}

export default createStore({
  state: {
    activities: null,
    activitiesList: null,
    selectedActivityKey: null,
    session: null,
    timeLabel: null,
    time: 0,
    timeFrame: 'Semaine',
    siteInfo: {},
    loading: true,
    loadingContent: false,
    displayContentConfig: null,
    selected: [],
    selectedActivity: null,
    calendarDays: [],
    openedParticipants: [],
    impersonateData: null,
    contremarque: false,
    reload: 0,
    billetType: null
  },
  actions,
  mutations,
  getters,
  plugins: [createPersistedState({ 
    key: storeKey,
    paths: ['impersonateData'] 
  })]
});
